import { render } from "./FreeSub.vue?vue&type=template&id=b219e55c"
import script from "./FreeSub.vue?vue&type=script&lang=js"
export * from "./FreeSub.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__